<template>
  <div id="app">
    <router-view></router-view>
    <!--<kn-mainContainer></kn-mainContainer> -->
  </div>
</template>

<script>
import mainContainer from "./components/mainContainer.vue"

export default {
  components: {
    "kn-mainContainer": mainContainer
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

body {
  font-family: 'Inter', sans-serif;
  background-color: #f4f6f9;
  min-height: 100vh;
  color: #0f172a;
  margin: 0;
  padding: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Removing the old noisy container backgrounds */
.container,
.container-fluid {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.main-content {
  text-align: center;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  color: #0c4a6e;
  /* Deep ocean blue for headers */
}

a {
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: #0284c7;
  /* Vibrant Greek blue */
}
</style>



// WEBPACK FOOTER //
// src/App.vue